import request from '@/modules/huyu-framework/backend/utils/request'

// 查询模块列列表
export function listModuleList(query) {


  return request({
    url: '/project/moduleList/list',
    method: 'get',
    params: query
  })
}

// 查询模块列详细
export function getModuleList(moduleId) {
  return request({
    url: '/project/moduleList/' + moduleId,
    method: 'get'
  })
}
// 查询模块授权的菜单
export function getModuleMenu(moduleId) {
  return request({
    url: '/project/moduleList/getModuleMenu/' + moduleId,
    method: 'get'
  })
}



// menuId
// 新增模块列
export function addModuleList(data) {
  return request({
    url: '/project/moduleList',
    method: 'post',
    data: data
  })
}

// 修改模块列
export function updateModuleList(data) {
  return request({
    url: '/project/moduleList',
    method: 'put',
    data: data
  })
}

// 删除模块列
export function delModuleList(moduleId) {
  return request({
    url: '/project/moduleList/' + moduleId,
    method: 'delete'
  })
}
